import { Injectable } from "@angular/core";
import { Topics } from "@common/interfaces/topics";
import { IID_EP_ASSET } from "@common/interfaces/interfaceData";
import { ID } from '@common/interfaces/id';
import { EntityState, EntityStore, StoreConfig } from "@datorama/akita";

export interface IIDepAssetsState extends EntityState<IID_EP_ASSET, ID> { }

@Injectable({
  providedIn: 'root'
})
@StoreConfig({ name: Topics.IID_EP_ASSET })
export class IIDepAssetsStore extends EntityStore<IIDepAssetsState> {
  constructor() {
    super([]);
  }
}
